document.addEventListener('DOMContentLoaded', function () {
  // Accordions
  document.querySelectorAll('.acc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var acc = btn.closest('.acc');
      var open = acc.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var mark = btn.querySelector('span');
      if (mark) mark.textContent = open ? '–' : '+';
    });
  });

  // Product gallery: full-frame swap (srcset cleared so the swap truly shows) + lightbox
  var main = document.getElementById('MainProductImage');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.g-thumb'));
  var current = 0;
  var lb = document.getElementById('Lightbox');
  var lbImg = document.getElementById('LightboxImg');
  function showPhoto(i) {
    if (!thumbs.length) return;
    current = ((i % thumbs.length) + thumbs.length) % thumbs.length;
    var full = thumbs[current].getAttribute('data-full');
    if (main && full) {
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = full;
    }
    thumbs.forEach(function (tb, j) { tb.classList.toggle('active', j === current); });
    if (lb && !lb.hidden && lbImg && full) lbImg.src = full;
  }
  var twrap = document.querySelector('.g-thumbs');
  if (twrap) {
    twrap.addEventListener('click', function (e) {
      var b = e.target.closest('.g-thumb');
      if (b) showPhoto(thumbs.indexOf(b));
    });
  }
  if (main) {
    main.style.cursor = 'zoom-in';
    main.setAttribute('title', 'Click to enlarge');
    main.addEventListener('click', function () {
      if (lb && lbImg) {
        lbImg.src = thumbs.length ? thumbs[current].getAttribute('data-full') : main.src;
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
      }
    });
  }
  function closeLb() { if (lb) { lb.hidden = true; document.body.style.overflow = ''; } }
  if (lb) {
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    var c = document.getElementById('LbClose'); if (c) c.addEventListener('click', closeLb);
    var pv = document.getElementById('LbPrev'); if (pv) pv.addEventListener('click', function () { showPhoto(current - 1); });
    var nx = document.getElementById('LbNext'); if (nx) nx.addEventListener('click', function () { showPhoto(current + 1); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowLeft') showPhoto(current - 1);
      if (e.key === 'ArrowRight') showPhoto(current + 1);
    });
  }

  // Bundle picker drives the real variant select + prices
  var select = document.getElementById('VariantSelect');
  var priceEl = document.getElementById('ProductPrice');
  var btnPrice = document.getElementById('BtnPrice');
  var compareEl = document.getElementById('ProductCompare');
  function setCompare(src) {
    if (!compareEl) return;
    var c = src ? src.getAttribute('data-compare') : null;
    if (c) { compareEl.textContent = c; compareEl.style.display = ''; }
    else { compareEl.style.display = 'none'; }
  }
  function syncFromSelect() {
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    if (opt && priceEl) priceEl.textContent = opt.getAttribute('data-price');
    if (opt && btnPrice) btnPrice.textContent = opt.getAttribute('data-price');
    setCompare(opt);
  }
  document.querySelectorAll('input[name="bundle-option"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (select) { select.value = radio.getAttribute('data-variant-id'); syncFromSelect(); }
      if (priceEl) priceEl.textContent = radio.getAttribute('data-price');
      if (btnPrice) btnPrice.textContent = radio.getAttribute('data-price');
      setCompare(radio);
    });
  });
  if (select) select.addEventListener('change', syncFromSelect);
});
